import { createContext, useContext } from 'react';
import { useFeatureFlags } from '../hooks/useFeatureFlags';

const FeatureFlagContext = createContext();

export const FeatureFlagProvider = ({ children }) => {
  const { flags, loading } = useFeatureFlags();

  return (
    <FeatureFlagContext.Provider value={{ flags, loading }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlagsContext = () => useContext(FeatureFlagContext);